
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE, } from "../../redux/features/CartData";
import { CLEARCUSTOMIZEDDATA } from "../../redux/features/CustomizedData";
import GetStepOptionId from "../../utils/CustomizedCalculation/GetStepOptionId";
import getSubData from "../../utils/CustomizedCalculation/GetSubData";
import GetCustomizedSubTotal from "../../utils/CustomizedCalculation/GetSubTotal";
import selectOptionData from "../../utils/CustomizedCalculation/SelectOptionData";
import { GetTotalPrice } from "../../utils/GetTotalPrice";
import ParseFloat from "../../utils/ParseFloat";
import { SortVarition } from "../../utils/SortVariation";
import { TaxCalcualate } from "../../utils/TaxCalculate";
// import { Vibrate } from "../../utils/Vibrate/Vibrate";
import ItemOption, { ItempOptionSelectRadio } from "../RightSideBar/ItemOption/ItemOption";
// import ItemTitleDetail from "../RightSideBar/ItemTitleDetail/ItemTitleDetail";
import ItemVariationView from "../RightSideBar/ItemVariationView/ItemVariationView";
import StepTitle from "../RightSideBar/StepTitle/StepTitle";
// import { SuccessToast } from "../ToastComponent/SuccessToast";
import { GetItemPrice } from "../../utils/GetItemPrice";
import Konsole from "../../utils/konsole/Konsole";
import { PriceReturnForMeal } from "../../utils/CustomizedCalculation/MealPrice";
import StoreDescription from "../Store/Store-Description";
import SelectAddOnData from "../../utils/CustomizedCalculation/SelectAddOnData";
import AddOnData from "../RightSideBar/AddOnData/AddOnData";
import { useTranslation } from "react-i18next";
import { refPageModal, refPageRoute } from "../../constant/constant";
import useMobile from "../../hooks/useMobile";
import useDeviceIos from "../../hooks/useDeviceIos";
import DescriptionMoreLess from "../Read-More/DescriptionMoreLess";
import GlobalButton from "../Buttons/btn2/GlobalButton";
import { isTaxInclusive } from "../../utils/helper";
import useCartData from "../../hooks/useCartData";
interface customeType {
  onCloseModal?: any;
  taxdata?: any;
  menu_id?: any;
  refrencePage?: any
}
const CustomizeItemSelection = ({ refrencePage, onCloseModal, menu_id, taxdata, }: customeType) => {
  const { CheckCustomizeItems } = useCartData()
  const { customizedData, cartData: { itemCount, items }, }: any = useSelector((state: any) => state);
  const [selectedVariation, setSelectedVariation] = useState<any>();
  const [stepOptionId, setStepOptionId] = useState<any>([]);
  const [categoryId, setCategoryId] = useState<any>([]);
  const [selectAddOn, setSelectedAddOn] = useState<any>([]);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [finalPrice, setFinalPrice] = useState(0);
  const [error, setError] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const { t } = useTranslation()
  const mobile = useMobile();
  const device = useDeviceIos();

  menu_id = refrencePage == refPageRoute ? customizedData?.menu_id_for_page : menu_id;
  taxdata = refrencePage == refPageRoute ? customizedData?.textdata_for_page : taxdata;


  useEffect(() => {
    if (customizedData) {
      setSelectedVariation(SortVarition(customizedData)?.item_variation[0]);
    }
    if (customizedData.isEdit) {
      setFinalPrice(customizedData?.total_price);
      setStepOptionId(customizedData.selectedoptions);
      setCategoryId(customizedData.selectedCategory);
      setSelectedVariation(customizedData.selected_variation);
      setSelectedAddOn(customizedData?.selected_addOn);
      setQuantity(customizedData.quantity);
    }
  }, [customizedData]);

  const isMealItem = useMemo(() => {
    return customizedData?.is_meal;
  }, [customizedData])



  // Konsole.log("finalPrice", finalPrice);

  // Validate steps and category
  const isValidate = (customizeData: any) => {
    Konsole.log("customizeData", customizeData);

    // @@ steps validate
    const _reqSteps = customizeData?.item_step?.filter((iStep: any) => iStep?.required == 1);
    // console.log('_reqStepsa', _reqSteps)
    if (_reqSteps?.length > 0) {
      Konsole.log("_reqSteps", _reqSteps);
      if (stepOptionId?.length == 0) {
        return false;
      }
      const matchValidate_step = _reqSteps?.map((i: any) => stepOptionId.find((data1: any) => data1?.step_id === i?.item_step_id)).filter(Boolean);
      Konsole.log("matchValidate", matchValidate_step);
      if (_reqSteps?.length > matchValidate_step?.length) {
        return false;
      }
    }
    Konsole.log("_reqSteps", _reqSteps, stepOptionId);
    // @@ catrgory validate
    const _reqCateg = customizeData?.step_sub_category_data?.filter((item: any) => item?.required == "1");
    Konsole.log("_reqCatega", _reqCateg);
    if (_reqCateg?.length > 0) {
      Konsole.log("_reqStepsab", categoryId, _reqCateg);
      if (categoryId?.length == 0) {
        return false;
      }
      const matchValidate_catg = _reqCateg?.map((i: any) => categoryId.find((data1: any) => data1?.side_id == i?.item_step_id)).filter(Boolean);
      Konsole.log("matchValidate", matchValidate_catg);
      if (_reqCateg?.length > matchValidate_catg?.length) {
        return false;
      }
    }
    return true;
  };
  // add to cart ...........
  const addToCart = async () => {
    const item = structuredClone(customizedData);
    const res = isValidate(item);
    Konsole.log("resres", res);
    if (!res) {
      setError(true);
      scrollError();
      return;
    }

    let selectedOptionsData = GetStepOptionId({ selectedVariation, stepOptionId, })

    if (CheckCustomizeItems(item, selectedVariation, selectAddOn, selectedOptionsData, categoryId, quantity)) {
      closeModal()
      return;
    }

    item["selectedoptions"] = selectedOptionsData;
    item["selectedCategory"] = categoryId;
    item["selected_addOn"] = selectAddOn;
    item["quantity"] = quantity;
    item["selected_variation"] = selectedVariation;
    item["menu_id"] = menu_id;
    const TaxData = TaxCalcualate(taxdata, finalPrice * quantity, 1);
    item["total_price"] = isTaxInclusive(TaxData.tax_inclusive_exclusive_type) ? Number(finalPrice * quantity) : Number(finalPrice * quantity) + TaxData.fixedTax + (Number(finalPrice * quantity) * TaxData.percentageTax) / 100;

    // item["price"] = selectedVariation?.variation_price ? parseFloat(selectedVariation?.variation_price ? selectedVariation?.variation_price : item.web_price) : item?.map_store_item?.length > 0 ? parseFloat(item?.map_store_item[0]?.offered_price) : parseFloat(item.web_price);
    item["price"] = selectedVariation?.variation_price
      ? parseFloat(selectedVariation?.web_price ? selectedVariation?.web_price : selectedVariation.variation_price)
      : item?.map_store_item?.length > 0
        ? parseFloat(item?.map_store_item[0]?.offered_price)
        : item?.web_price ? parseFloat(item?.web_price) : parseFloat(item.price);
    item["map_tax_class"] = taxdata.map_tax_class;
    item["tax_class"] = taxdata.tax_class;
    item["sub_total"] = finalPrice;
    item["tax_rate_list"] = TaxData.taxArray;


    // @@ if edit
    if (customizedData?.isEdit) {
      item["selected_addOn"] = customizedData?.selected_addOn;
      const findData = items;
      const ui = findData.find((e: any) => e.uniqueIndex === item.uniqueIndex);
      const index = findData.indexOf(ui);
      findData.splice(index, 1, item);
      dispatch(SETCARTDATA(findData));
      dispatch(SETCARTTOTALPRICE(GetTotalPrice(findData)));
      dispatch(CLEARCUSTOMIZEDDATA({}));
      dispatch(SETCARTCOUNT(itemCount + (quantity - customizedData.quantity)));
      onCloseModal();
      if (sessionStorage.getItem("backCheckout") == "1") {
        navigation("/checkout");
        sessionStorage.removeItem("backCheckout");
      }
    } else {
      if (items.length > 0) {
        const allItems = items;
        item["uniqueIndex"] = allItems.length > 0 ? allItems[items.length - 1].uniqueIndex + 1 : 1;
        allItems.push(item);
        dispatch(SETCARTDATA(allItems));
        dispatch(SETCARTCOUNT(itemCount + quantity));
        closeModal()
        dispatch(SETCARTTOTALPRICE(GetTotalPrice(allItems)));
      } else {
        item["uniqueIndex"] = 1;
        const array = [item];
        // console.log('arrayarray',array)
        dispatch(SETCARTDATA(array));
        dispatch(SETCARTCOUNT(itemCount + quantity));
       closeModal()
        dispatch(SETCARTTOTALPRICE(GetTotalPrice(array)));
      }
    }
  };

  const closeModal = () => {
    dispatch(CLEARCUSTOMIZEDDATA({}));
    onCloseModal();
  }
  // update price ..........
  useEffect(() => {
    setFinalPrice(GetCustomizedSubTotal({ selectAddOn, stepOptionId, categoryId, customizedData, selectedVariation, }));
  }, [selectedVariation, stepOptionId, categoryId, customizedData, selectAddOn]);

  // Function to scroll to an element by its ID
  const scrollError = () => {
    setTimeout(() => {
      const element = document.getElementById("errorScroll");
      Konsole.log("elementelement", element);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", });
      }
    }, 1);
  };

  const imageUrl = useMemo(() => {
    let imgUrl = customizedData?.item_attachment?.base_url + customizedData?.item_attachment?.attachment_url;
    return imgUrl ? imgUrl : '/images/no_image_available.svg';
  }, [customizedData]);


  const isVariationAvailable = useMemo(() => {
    return customizedData?.item_variation && customizedData?.item_variation?.length > 0
  }, [customizedData])



  // for scrolling
  // useEffect(() => {
  //   if (open) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'auto';
  //   }
  //   return () => {
  //     document.body.style.overflow = 'auto';
  //   };
  // }, [open]);
  // for scrolling
  // Konsole.log("customizedData", customizedData, items);
  // Konsole.log('isMealItem', isMealItem)
  return (
    <>
      {/* <div className="relative md:h-[calc(100vh-7rem)] h-[calc(100vh-4rem)] scroll-hidden overflow-y-auto"> */}
      {/* <div className={(mobile && device) ? "mt-16 relative md:h-[calc(100vh-8rem)] h-[calc(100vh-5rem)]  overflow-y-auto scroll-hidden scroll-touch-screen  " : "relative md:h-[calc(100vh-8rem)] h-[calc(100vh-5rem)]  overflow-y-auto scroll-hidden scroll-touch-screen  "} > */}
      <div className={"relative h-full overflow-y-auto scroll-hidden scroll-touch-screen  "} >

        <div className="h-48 relative  ">
          <img src={imageUrl} className="absolute object-cover w-full h-full" />
        </div>

        <div className="md:px-8 px-3 pb-20 scroll-hidden pointer-events-auto touch-auto">
          <div className="flex justify-between items-center sticky top-0 bg-white py-3 z-50">
            {customizedData?.name && (
              <h4 className={`md:text-[2rem] text-xl font-normal font-splekta ${!isVariationAvailable ? 'pt-6' : ''}`} >
                {customizedData?.name}

                {(!isVariationAvailable) && <>
                  <br />
                  <span className="textMd text-[#4B4B4B] font-normal"> {ParseFloat(GetItemPrice(customizedData))} </span></>}
              </h4>
            )}


            {(!isVariationAvailable) ? <p className="text-[#4B4B4B] md:text-xl text-base font-bold">
              {/* {ParseFloat(GetItemPrice(customizedData))} */}
              <ItempOptionSelectRadio {...customizedData} />
            </p> : null}

          </div>

          {/* <div className="md:px-8 px-3 pb-20 pointer-events-auto touch-auto"> */}
          {/* @@ description of item */}
          {/* <StoreDescription store={customizedData} refrencePage={'CustomizeModal'} /> */}
          {customizedData?.description ? <DescriptionMoreLess text={customizedData?.description} /> : ''}

          <hr className="border-b-2 border-[#ECECEC] my-2" />
          {/*--------------------- variation Start ------------------------- */}
          <div className="variationSection mb-2">
            {customizedData.item_variation && customizedData.item_variation.length > 0 && (
              <StepTitle stepTitle={t("Home.pleaseSelectVariations")} err={false} success={true} />
            )}


            {selectedVariation &&
              customizedData?.item_variation.map((data: any, index: number) => {
                const store_variation_price = customizedData?.map_store_item_variation?.find((variation: any) => variation.variation_id === data.variation_id);
                return (
                  <ItemVariationView
                    key={index}
                    selectedId={selectedVariation?.id}
                    price={store_variation_price ? store_variation_price.offered_variation_price : data.web_price}
                    id={data.id}
                    itemName={data?.variation_detail[0]?.variation_name}
                    onchange={() => setSelectedVariation(data)}
                  />
                );
              })}
          </div>
          {/*--------------------- variation End ------------------------- */}
          {/* --------------------- Option Start -------------------------- */}
          {customizedData?.item_step?.map((stepList: any) => {
            const errorVal = error && stepList?.required == 1 && stepOptionId?.filter((obj: any) => { return obj.step_id === stepList?.item_step_id; })?.length == 0;
            const id = errorVal ? "errorScroll" : "noScroll";
            return (
              <div id={id} className="variationSection mb-2" key={stepList.item_step_id}>
                {stepList?.option?.length > 0 && (
                  <StepTitle
                    key={stepList.item_step_id}
                    stepTitle={stepList?.title}
                    required={stepList?.required == 1}
                    err={errorVal}
                    success={stepList?.required == 1 && stepOptionId?.filter((obj: any) => { return obj.step_id === stepList?.item_step_id; })?.length
                    }
                  />
                )}

                <span className="textMd text-[#4B4B4B]"> {t("Home.choose")} {stepList.max_count} </span>

                {stepList?.option?.map((optionData: any) => {
                  return (
                    <div key={optionData?.item_step_option_id}>
                      <ItemOption
                        defaultChecked={
                          customizedData.isEdit && customizedData.selectedoptions.find((e: any) => e.item_step_option_id === optionData.item_step_option_id) ? true : false
                        }
                        id={optionData?.item_step_option_id}
                        // price={optionData?.web_price}

                        price={PriceReturnForMeal(isMealItem, optionData?.web_price)}
                        itemName={optionData?.title}
                        disabled={
                          stepOptionId.filter((obj: any) => {
                            return obj.step_id === stepList.item_step_id;
                          })?.length == stepList.max_count &&
                          stepOptionId.find((obj: any) => {
                            return (obj.item_step_option_id === optionData.item_step_option_id);
                          }) == undefined
                        }
                        onchange={(e: any) => {
                          setError(false);
                          selectOptionData({ e, optionData, stepList, stepOptionId, setStepOptionId, });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
          {/* --------------------- Option End -------------------------- */}
          {/* --------------------- Category Start -------------------------- */}

          {customizedData?.step_sub_category_data?.map((stepList: any) => {
            Konsole.log("stepListstepList", stepList, customizedData);
            const errorVal = error && stepList?.required == 1 && categoryId?.filter((obj: any) => { return obj.side_id === stepList?.item_step_id; })?.length == 0;
            const id = errorVal ? "errorScroll" : "noScroll";
            return (
              <>
                {stepList ? (
                  <div id={id} className="variationSection mb-2" key={stepList.item_step_id}>
                    {stepList?.map_item_side?.length > 0 && (
                      <StepTitle
                        key={stepList.item_step_id}
                        stepTitle={stepList?.title}
                        required={stepList?.required == 1}
                        err={error && stepList?.required == 1 &&
                          categoryId?.filter((obj: any) => {
                            return obj.side_id === stepList?.item_step_id;
                          })?.length == 0
                        }
                        success={
                          stepList?.required == 1 &&
                          categoryId?.filter((obj: any) => {
                            return obj.side_id === stepList?.item_step_id;
                          })?.length
                        }
                      />
                    )}

                    <span className="textMd text-[#4B4B4B]"> {t("Home.choose")} {stepList.max_count}</span>

                    {stepList?.map_item_side?.map((optionData: any) => {
                      return (
                        <>
                          {optionData ? (
                            <div key={optionData?.item_id}>
                              <ItemOption
                                defaultChecked={
                                  customizedData.isEdit && customizedData.selectedCategory.find((e: any) => e.item_id === optionData.item_id) ? true : false
                                }
                                id={optionData?.item_id}
                                // price={optionData?.mapNewItem?.web_price}

                                price={PriceReturnForMeal(isMealItem, optionData?.mapNewItem?.web_price)}
                                itemName={optionData?.mapNewItem?.name}
                                disabled={
                                  categoryId.filter((obj: any) => {
                                    return (obj.side_id === stepList?.item_step_id);
                                  })?.length == stepList.max_count &&
                                  categoryId.find((obj: any) => {
                                    return obj.item_id === optionData.item_id;
                                  }) == undefined
                                }
                                onchange={(e: any) =>
                                  getSubData({ e, optionData, stepList, categoryId, setCategoryId, customizedData, })
                                }
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
              </>
            );
          })}
          {/* --------------------- Category End -------------------------- */}

          {/* @@ ADD On DATA */}

          <AddOnData
            key={selectAddOn}
            selectAddOn={selectAddOn}
            setSelectedAddOn={setSelectedAddOn}
            addon_data={customizedData?.addon_data}
            refrencePage={'CustomizeModal'}
          />


          {/* <StepTitle stepTitle="You may also want" /> */}
          {/* <input type="checkbox" id="addon" name="addon" />
        <label htmlFor="addon" className="!inline-flex !gap-10">
          <span>Rose Churma </span>
          <div>
            <span className="text-[.7em] line-through mr-1">80.00</span>
            <span className="font-bold">70.00</span>
          </div>
        </label> */}
        </div>
      </div>

      <div className="fixed bottom-0 w-full bg-white touch-auto pointer-events-auto md:px-8 px-3 py-4 border-t border-[#ECECEC]">
        <div className=" flex justify-between ">
          <div className="allCounterButton ">
            <span className="rounded-full border border-gray-400  p-2 cursor-pointer" onClick={() => setQuantity((pre) => (pre > 1 ? pre - 1 : pre))}>
              <svg width="12" height="12" viewBox="0 0 38 5" fill="currentColor">
                <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z"></path>
              </svg>
            </span>

            <span className="prevent-select-disable">{quantity}</span>

            <span onClick={() => setQuantity((pre) => pre + 1)} className="rounded-full border border-gray-400  p-2 cursor-pointer"  >
              <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
              </svg>
            </span>
          </div>

          {/* <button onClick={addToCart} className=" lg:w-1/2 inline-flex justify-center md:gap-14 btn-secondary !px-4 py-4" >
            <div className="flex gap-3 prevent-select-disable">
              {t("Home.addToOrder")} - <span className="">{ParseFloat(quantity * finalPrice)}</span>
            </div>
          </button> */}
          <GlobalButton className="md:w-1/3 lg:w-1/3 xl:w-1/3"
            onClick={addToCart}
            label={`${t("Home.addToOrder")} ${"   -  "}${ParseFloat(quantity * finalPrice)}`}
          />
        </div>
      </div>

      <ToastContainer style={{ zIndex: "999999999" }} />
    </>
  );
};
export default CustomizeItemSelection;
